import axiosInstance from "./axiosInstance";

class VoucherService {
  static async find({
    keyword,
    productIds,
  }: {
    keyword: string;
    productIds: number[];
  }) {
    const res = await axiosInstance.get("/vouchers/active", {
      params: {
        keyword,
        productIds: productIds.toString(),
        pageSize: 1,
        pageIndex: 0,
      },
    });
    return res.data.result as PageResult<VoucherResponse>;
  }
}

export default VoucherService;
